export const publicVersion = "2.6.1-67-g49ab50af-2026-04-29T20-38-29Z";